module.exports = __webpack_public_path__ + "static/image/company/principle@2x.jpg?2a7cdeb6";